import { Paper } from '@material-ui/core';
import React from 'react';

const ContentDisplayContainer = (props) => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-12 my-3">
        <Paper className="py-3 px-4" style={{ minHeight: '80dvh' }}>
          <div className="d-flex flex-column pl-1">
            {props.children}
          </div>
        </Paper>
      </div>
    </div>
  </div>
);

export default ContentDisplayContainer;
